/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, string, func, bool, number,
} from 'prop-types';
import ReactMarkdown from 'react-markdown';
import Fade from '@material-ui/core/Fade';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import { Link } from 'react-router-dom';
import { useUIDSeed } from 'react-uid';
import LazyLoad from 'react-lazyload';
import { SideBySideMagnifier } from 'react-image-magnifiers';
import { clubComponentType } from '../common/types';
import GraphqlSlider from '../../../GraphqlCommonComponents/GraphqlSlider/GraphqlSlider';
import { snipePath } from '../common/commonProductPageHelper';
import SnipeRender from '../common/SnipeRender';

const styles = (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        background: theme?.palette?.white,
        [theme?.breakpoints?.down('md')]: {
            flexDirection: 'column',
            justifyContent: 'flex-start',
        },
    },
    monthList: {
        display: 'flex',
    },
    monthDetailContainer: {
        display: 'flex',
        position: 'relative',
        margin: '0 auto',
        maxWidth: 1080,
    },
    leftNav: {
        marginTop: '100px',
        border: '0',
        cursor: 'pointer',
        transform: 'rotate(90deg)',
        background: 'transparent',
        height: 'fit-content',
        '&:focus': {
            outline: 'none', // TODO: Need to add outline for accessibility
        },
    },
    flexContainer: {
        display: 'flex',
    },
    productImageWrapperMonth: {
        flex: '1 1 auto',
        maxWidth: '300px',
        minWidth: '300px',
        height: '100%',
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            order: '1',
        },
    },
    productImage: {
        width: '100%',
        height: 'auto',
        [theme?.breakpoints?.down('md')]: {
            height: 'auto',
        },
    },
    monthDescriptionSummary: {
        minWidth: '500px',
        marginLeft: '50px',
        [theme.breakpoints.down('md')]: {
            marginLeft: '0px',
            minWidth: '254px',
        },
    },

    nextNav: {
        marginTop: '100px',
        border: '0',
        cursor: 'pointer',
        transform: 'rotate(-90deg)',
        background: 'transparent',
        height: 'fit-content',
        '&:focus': {
            outline: 'none', // TODO: Need to add outline for accessibility
        },
    },
    productImageWrapperClub: {
        display: 'inline-block',
        margin: '0',
        minWidth: '200px',
        maxWidth: '600px',
        height: '100%',
        position: 'relative',
        [theme?.breakpoints?.down('md')]: {
            marginLeft: '20px',
        },
        [theme?.breakpoints?.down('sm')]: {
            marginLeft: 0,
            maxWidth: '100%',
        },
    },
    imageContainer: {
        position: 'relative',
        cursor: 'pointer',
    },
    productImageWrapper: {
        flex: '1 1 auto',
        order: '2',
        maxWidth: '600px',
        height: '100%',
        position: 'relative',
        [theme?.breakpoints?.down('md')]: {
            order: '1',
        },
    },
    snipe: {
        position: 'absolute',
        bottom: '4px',
        right: '0',
        left: '0',
        width: '100%',
    },
    prevLink: {
        transform: 'rotate(90deg)',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        boxSizing: 'border-box',
        color: theme.palette.desktopHeaderMenu?.text || '#333333',
        textAlign: 'center',
        lineHeight: 'normal',
        '&:focus': {
            outline: 'none', // TODO: Need to add outline for accessibility
        },
    },
    nextLink: {
        transform: 'rotate(-90deg)',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        boxSizing: 'border-box',
        color: theme.palette.desktopHeaderMenu?.text || '#333333',
        textAlign: 'center',
        lineHeight: 'normal',
        '&:focus': {
            outline: 'none', // TODO: Need to add outline for accessibility
        },
    },
    monthSnipe: {
        position: 'absolute',
        right: 0,
        left: 0,
        bottom: 0,
        padding: 5,
        backgroundColor: 'rgba(47,47,47, .9)',
        boxSizing: 'border-box',
        color: theme.palette.cms?.primary_font_color || '#ffffff',
        textAlign: 'center',
    },
    upsellSelected: {
        '& span': {
            backgroundColor: theme.palette.primaryButton || '#a1001a',
        },
    },
    upsellImageBox: {
        display: 'inline-block',
        flexWrap: 'wrap',
        marginRight: '10px',
        maxWidth: '110px',
        [theme.breakpoints.down('md')]: {
            order: '2',
            margin: '20px 0 0 0',
            display: 'flex',
            maxWidth: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            order: '2',
            margin: '20px 0 0 0',
            display: 'inline-block',
            maxWidth: '100%',
        },
        '&:hover span': {
            backgroundColor: theme.palette.primaryButton || '#a1001a',
        },
        '&:last-child': {
            margin: 0,
        },
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        '& .slick-list': {
            display: 'none',
        },
        [theme.breakpoints.down('md')]: {
            width: '92%',
            margin: '0 auto',
        },
        [theme.breakpoints.down('sm')]: {
            width: '95%',
            display: 'block',
            margin: '0 auto',
            '& .slick-slide': {
                float: 'left',
                whiteSpace: 'nowrap',
            },
            '& .slick-list': {
                display: 'block',
            },

        },
    },
    clubLengthHeadline: {
        color: theme.palette.cms?.primary_font_color || '#ffffff',
        position: 'absolute',
        textAlign: 'center',
        backgroundColor: 'rgba(47,47,47, .9)',
        bottom: '5px',
        right: '0',
        left: '0',
        padding: '5px',
        '&:hover': {
            backgroundColor: theme.palette.cms?.primary || '#a1001a',
        },
    },
    closeIcon: {
        position: 'absolute',
        top: '13px',
        right: '13px',
        cursor: 'pointer',
    },
});

const ClubPDPImageDesktop = ({
    classes,
    modalOpen,
    handleState,
    product,
    cdnLink,
    clubComponents,
    getSlides,
    selectedComponentMonth,
    navigate,
    renderZoom,
    shouldRenderSnipe,
    getClubLengthDescription,
    presentation_family,
    renderSnipe,
    heroImage,
    personalizationFlag,
}) => {
    const seed = useUIDSeed();
    return (
        <div className={classes.root}>
            <Dialog
                open={modalOpen}
                maxWidth={false}
                onClose={() => { handleState({ modalOpen: false, selectedComponentMonth: null }); }}
            >
                <DialogTitle>
                    <CloseIcon data-testid="club-component-detail-modal-close" onClick={() => { handleState({ modalOpen: false, selectedComponentMonth: null }); }} className={classes.closeIcon} />
                </DialogTitle>
                <DialogContent data-testid="club-component-detail-modal">
                    <div className={classes.monthList}>
                        {(getSlides(clubComponents) || []).map((component) => (
                            <React.Fragment key={seed(component)}>
                                {component}
                            </React.Fragment>
                        ))}
                    </div>
                    {clubComponents?.[selectedComponentMonth] && (
                        <div className={classes.monthDetailContainer}>
                            <button
                                type="button"
                                data-testid="navigate-click-prev"
                                onClick={() => {
                                    navigate('prev');
                                }}
                                className={classes.leftNav}
                            ><img alt="Prev" src="https://cdn2.harryanddavid.com/wcsstore/HarryAndDavid/images/path_10_copy_2_u202.svg" />
                            </button>
                            <div data-testid={`selected-component-${selectedComponentMonth}`} className={classes.flexContainer}>
                                <div className={classes.productImageWrapperMonth}>
                                    <img
                                        className={classes.productImage}
                                        src={`${cdnLink}${clubComponents[selectedComponentMonth].image?.name}${'x.jpg'}`}
                                        alt={clubComponents[selectedComponentMonth].name}
                                    />
                                </div>
                                <div className={classes.monthDescriptionSummary}>
                                    <h2>{clubComponents[selectedComponentMonth].month} - {clubComponents[selectedComponentMonth].name}</h2>
                                    <p>
                                        <ReactMarkdown
                                            source={clubComponents[selectedComponentMonth].longDescription || ''}
                                            escapeHtml={false}
                                        />
                                        <ReactMarkdown
                                            source={clubComponents[selectedComponentMonth].productContents || ''}
                                            escapeHtml={false}
                                        />
                                    </p>
                                </div>
                            </div>
                            <button
                                type="button"
                                data-testid="navigate-click-next"
                                onClick={() => {
                                    navigate();
                                }}
                                className={classes.nextNav}
                            ><img alt="Next" src="https://cdn2.harryanddavid.com/wcsstore/HarryAndDavid/images/path_10_copy_2_u202.svg" />
                            </button>
                        </div>
                    )}
                </DialogContent>
            </Dialog>
            <div className={classes.productImageWrapperClub}>
                <div
                    data-testid="hero-image-click"
                    onClick={() => { handleState({ modalOpen: true, selectedComponentMonth: 0 }); }}
                    onKeyDown={() => { }}
                    role="button"
                    tabIndex="0"
                    className={classes.imageContainer}
                >
                    {renderZoom()
                        ? (
                            <SideBySideMagnifier
                                className={classes.productImage}
                                imageSrc={heroImage}
                                imageAlt={product.name}
                                largeImageSrc={heroImage}
                            />
                        ) : (
                            <img src={heroImage} alt={product?.name} className={classes?.productImage} />
                        )}
                    {presentation_family === 'food' && renderSnipe && shouldRenderSnipe(product?.image?.snipe, personalizationFlag) /* data?.image && data?.image.snipe */ ? ( // if snipe data exsist display snipe img
                        <LazyLoad>
                            <Fade in timeout={700}>
                                <SnipeRender
                                    altText={product?.image?.altText}
                                    styleProp={classes.snipe}
                                    src={`${product?.image?.snipeImagePath}${product?.image?.snipe}_z.gif`}
                                    fallbackSrc={`${snipePath(product.image.path)}${product?.image?.snipe}_z.gif`}
                                />
                            </Fade>
                        </LazyLoad>
                    ) : null}
                    {getClubLengthDescription() && (
                        <div className={classes.clubLengthHeadline}>
                            {getClubLengthDescription()}
                        </div>
                    )}
                </div>
                <div className={classes.flexCenter}>
                    <GraphqlSlider
                        items={getSlides(clubComponents)}
                        itemsPerSlide={4}
                        prevLink={(
                            <img className={classes.prevLink} alt="Previous Link" src="https://cdn2.harryanddavid.com/wcsstore/HarryAndDavid/images/navigator.svg" />
                        )}
                        nextLink={(
                            <img className={classes.nextLink} alt="Next Link" src="https://cdn2.harryanddavid.com/wcsstore/HarryAndDavid/images/navigator.svg" />
                        )}
                        loop
                    />
                </div>
                <p><Link to="/h/view/custserv-handling">Shipping and Processing Details</Link></p>
            </div>
        </div>
    );
};

ClubPDPImageDesktop.defaultProps = {
    getSlides: () => { },
    modalOpen: false,
    handleState: () => { },
    product: {},
    cdnLink: '',
    selectedComponentMonth: 0,
    navigate: () => { },
    renderZoom: () => { },
    shouldRenderSnipe: () => { },
    getClubLengthDescription: () => { },
    presentation_family: 'food',
    renderSnipe: func,
    heroImage: '',
    personalizationFlag: false,
};

ClubPDPImageDesktop.propTypes = {
    classes: object.isRequired,
    longDescription: string.isRequired,
    clubComponents: clubComponentType.isRequired,
    getSlides: func,
    modalOpen: bool,
    handleState: func,
    product: object,
    cdnLink: string,
    selectedComponentMonth: number,
    navigate: func,
    renderZoom: func,
    shouldRenderSnipe: func,
    getClubLengthDescription: func,
    presentation_family: string,
    renderSnipe: func,
    heroImage: string,
    personalizationFlag: bool,
};

export default (withStyles(styles)(ClubPDPImageDesktop));
